var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLabel)?_c('div',[_c('p',{staticClass:"text-body-2 mb-0 rounded-xl py-1",class:[_vm.bgColor, _vm.textColor]},[_vm._v(" "+_vm._s(_vm.labelMessage)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }